// extracted by mini-css-extract-plugin
export default {"planConnector":"QuotaInsurancePlanStep_planConnector__3XYlP","planConnectorIcon":"QuotaInsurancePlanStep_planConnectorIcon__RPjaO"};